import React, { useState } from 'react';
import { Card, Row } from 'react-bootstrap';
import ButtonSave from '../Reusable/ButtonSave';
import { basicFormValidationHandler } from '../../utils';
import { isEmpty } from 'lodash';
import FirstSection from './Form/FirstSection';
import SecondSection from './Form/SecondSection';
import ThirdSection from './Form/ThirdSection';
import FourthSection from './Form/FourthSection';
import { emailPattern } from '../../constants/globals';

const FormExample = () => {
  const [state, setState] = useState({
    ipBrojImena: null,
    typeOfAuthor: null,
    firstName: null,
    lastName: null,
    parentName: null,
    dateOfBirth: null,
    placeOfBirth: null,
    dateOfRegistration: null,
    dateOfAuthorization: null,
    originCountry: '',
    gender: false,
    sortOfAuthor: null,
    jmbg: null,
    passportNumber: null,
    dateOfDeath: null,
    dateOfContractMP: null,
    dateOfContractPH: null,
    dateOfContractEP: null,
    residentStatus: 'resident',
    street: null,
    place: null,
    postalCode: null,
    postalAddressCode: null,
    municipality: null,
    taxNumber: null,
    country: null,
    postalStreet: null,
    postalAddress: null,
    postalNumber: null,
    postalReceiptAddressCode: null,
    postalCountry: null,
    phone1: null,
    phone2: null,
    phone3: null,
  });

  const [errors, setErrors] = useState({});

  const onChangeHandler = (event) => {
    changeState(event.target.name, event.target.value);
  };

  function changeState(propName, value) {
    setState((prevState) => ({ ...prevState, [propName]: value }));
  }

  const onDateChangeHandler = (date, value) => {
    changeState(date, value);
  };

  const onComboBoxChangeHandler = (name, value) => {
    changeState(name, value);
  };

  const clientValidationHandler = () => {
    const { lastName, typeOfAuthor, note, originCountry, email2 } = state;
    const errorsObject = basicFormValidationHandler(
      { lastName, typeOfAuthor, note, originCountry, email2 },
      {
        lastName: 'Potrebno je uneti prezime',
        note: 'Potrebno je uneti napomenu',
        date: 'Potrebno je uneti datum',
        typeOfAuthor: 'Potrebno je uneti tip autora',
        originCountry: 'Potrebno je uneti zemlju rođenja/osnivanja',
        email2: 'Potrebno je uneti imejl adresu',
      }
    );
    if (email2 && !emailPattern.test(email2)) {
      errorsObject['email2'] = 'Imejl adresa nije u odgovarajućem formatu';
    }
    setErrors(errorsObject);
    return !isEmpty(errorsObject);
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (clientValidationHandler()) return;
  };

  return (
    <Card className={`table-card-style default-card`}>
      <Card.Header className="table-card-header-style">
        <Card.Title className="d-flex gap-3 align-items-center">
          Primer forme
        </Card.Title>
      </Card.Header>
      <form noValidate={true} onSubmit={onSubmitHandler}>
        <Card.Body>
          <FirstSection
            state={state}
            onChange={onChangeHandler}
            onDateChange={onDateChangeHandler}
            onComboBoxChange={onComboBoxChangeHandler}
            errors={errors}
            errorsHandler={setErrors}
          />
          <SecondSection
            state={state}
            onChange={onChangeHandler}
            onDateChange={onDateChangeHandler}
            errors={errors}
            errorsHandler={setErrors}
          />
          <ThirdSection
            state={state}
            onChange={onChangeHandler}
            errors={errors}
            errorsHandler={setErrors}
          />
          <FourthSection
            state={state}
            onChange={onChangeHandler}
            errors={errors}
            errorsHandler={setErrors}
          />
        </Card.Body>
        <Card.Footer>
          <Row>
            <ButtonSave className="col-md-3 m-auto" />
          </Row>
        </Card.Footer>
      </form>
    </Card>
  );
};

export default FormExample;
